var _use, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckboxChecked = function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#CheckboxChecked_svg__a",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "CheckboxChecked_svg__a",
    fillRule: "evenodd",
    d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2M7 14 2 9.192l1.4-1.346L7 11.308 14.6 4 16 5.346z"
  }))));
};
export default SvgCheckboxChecked;